// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"736":"fdc8e5b7","798":"7bd05f0f","895":"2047cdfd"}[chunkId] + ".js";
};